import { type CollegamentoRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/collegamentoRichiestaDTO.ts';
import { CollegamentoRichiestaDTODirezione } from '@framework/api-client/api/inquiries-compile/schemas/collegamentoRichiestaDTODirezione.ts';
import { type CollegamentoRichiestaDTOTipo } from '@framework/api-client/api/inquiries-compile/schemas/collegamentoRichiestaDTOTipo.ts';

export class SubmissionLinkLogic {
  /**
   * Ritorna la prima istanza collegata in uscita per il tipo specificato
   */
  static getFirstOutboundLink(
    links?: CollegamentoRichiestaDTO[] | null,
    type?: CollegamentoRichiestaDTOTipo,
  ) {
    return (
      links?.find(
        link =>
          link.direzione === CollegamentoRichiestaDTODirezione.USCITA &&
          (!type || link.tipo === type),
      ) ?? null
    );
  }
}
